const Cart = () => import(/* webpackChunkName: "cart" */ './Cart');

export default {
  path: '/cart/:id',
  component: Cart,
  name: 'cart',
};